import { render, staticRenderFns } from "./BriqDialog.vue?vue&type=template&id=340cb502&scoped=true&lang=pug&"
import script from "./BriqDialog.vue?vue&type=script&lang=js&"
export * from "./BriqDialog.vue?vue&type=script&lang=js&"
import style0 from "./BriqDialog.vue?vue&type=style&index=0&id=340cb502&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340cb502",
  null
  
)

export default component.exports